/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {PeriodDetailModel} from '../models/period/period-detail/period-detail.model';
import {SpinnerService} from '../../shared/spinner/spinner.service';
import {PeriodTypeInfoChartModel} from '../models/period-type-info-chart/period-type-info-chart.model';
import {PeriodsViewsService} from '../services/periods-views/periods-views.service';
import {BundleDetailModel} from '../models/bundle/bundle-detail/bundle-detail.model';

@Component({
    selector: 'app-bundles-view',
    templateUrl: './bundles-view.component.html',
    styleUrls: ['./bundles-view.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BundlesViewComponent {
    @Output() refreshTableData = new EventEmitter<void>();
    @Output() refreshPeriodData = new EventEmitter<PeriodDetailModel>();

    // Local Loading Key
    private readonly LOCAL_LOADING_INSTANCE_KEY = 'PERIOD_LIST_LOADING';
    public spinnerObservable = this.spinnerService.onLocalChange(this.LOCAL_LOADING_INSTANCE_KEY);

    get bundlesListTitle(): string {
        return `BUNDLES LIST (${this.bundlesList?.length ?? 0})`;
    }

    get periodTypeInfoChartData(): Map<string, PeriodTypeInfoChartModel> {
        return this.periodsViewsService.getPeriodTypeInfoChartData();
    }

    get bundlesList(): BundleDetailModel[] {
        return this.periodsViewsService.getBundlesList();
    }

    constructor(public spinnerService: SpinnerService,
                private periodsViewsService: PeriodsViewsService) {
    }

    updatePeriodDetail(periodDetail: PeriodDetailModel): void {
        this.refreshPeriodData.emit(periodDetail);
    }
}
